import React, { useState } from "react";
import Image from "next/image";
import HireFromMilesForm from "@/components/forms/hireFromMilesForm";

const BrandAndAdvertisingTopTalentHFM = () => {
  const [isformPopupOpen, setformPopupOpen] = useState(false);

  const openformPopup = () => {
    setformPopupOpen(true);
  };

  const closeformPopup = () => {
    setformPopupOpen(false);
  };
  return (
    <section className="flex flex-col h-[600px] gap-3 w-full relative bg-no-repeat bg-contain bg-bottom bg-[#061a2f] rounded-t-[16px] shadow-[66px_87.333px_30.667px_0px_rgba(4,84,175,0),42.667px_56px_28px_0px_rgba(4,84,175,0.01),24px_31.333px_23.333px_0px_rgba(4,84,175,0.05),10.667px_14px_17.333px_0px_rgba(4,84,175,0.09),2.667px_3.333px_9.333px_0px_rgba(4,84,175,0.1)]">
      <div className="text-center">
        <h2 className="font-semibold 2xl:text-[24px] relative inline-block  md:text-[24px] text-[24px] md:text-black text-white text-center md:mb-1 mt-12">
          <span className="md:mt-1 md:pb-[5px] md:tracking-[-0.96px] pb-[5px] inline-block text-white">
            Hire Top Talent in <br></br>{" "}
            <span className="text-[36px] 2xl:text-[36px] md:text-[36px] md:tracking-[-1.44px] border-[#CA7216] border-b-[4px] md:pb-[5px] pb-[5px] inline-block text-white">
              Branding & Advertising
            </span>
          </span>
        </h2>
      </div>

      <div className="grid grid-cols-2 w-[70%] mx-auto">
        <div className="flex justify-end items-start">
          <Image
            loading="lazy"
            src="/hire-from-miles/brand-advertising-logo.svg"
            alt="Hire Accountants in India"
            className="mr-20"
            width={364}
            height={364}
          />
        </div>

        <div className="flex flex-col gap-3">
          <h3 className="text-white mt-16 2xl:w-[450px] 2xl:tracking-[-0.96px] leading-[28px] md:font-bold 2xl:text-[24px] md:text-[24px]">
            Connect With Next-Gen Business Talent
          </h3>
          <p className="text-white text-[20px] w-[580px] leading-6 font-normal">
            Access a dedicated talent pool of{" "}
            <span className="font-bold">Miles SOBA</span> graduates and
            students, ready to propel innovation and growth in your
            organization.
          </p>

          <div className="mt-8 md:block hidden relative ">
            <div className="flex md:justify-start items-center gap-4">
              <div
                onClick={openformPopup}
                className=" new_btn_branding_hire_from_miles new_btn_hire_graduate hire-from-miles-btn-textual"
              >
                Hire a Graduate
              </div>
              <div
                onClick={openformPopup}
                className=" new_btn_branding_hire_from_miles new_btn_hire_intern hire-from-miles-btn-textual"
              >
                Hire an Intern
              </div>
            </div>
          </div>
        </div>
      </div>

      {isformPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div className="rounded-[14px] shadow-lg relative lg:w-[500px] lg:h-[auto] md:w-[500px] h-[auto] mx-auto w-[365px] bg-white lg:py-6 lg:px-9 p-4">
            <button
              onClick={closeformPopup}
              className="mt-2 text-[#878787] px-3 text-lg py-1 rounded absolute right-[10px] top-[0px] z-[9999]"
            >
              ✕
            </button>
            <HireFromMilesForm />
          </div>
        </div>
      )}
    </section>
  );
};

export default BrandAndAdvertisingTopTalentHFM;
